import ReactDOM from 'react-dom/client'
import React from 'react'
import DatePickerField from './DatePickerField'
import DateTimePickerField from './DateTimePickerField'
import type { DatePickerProps, DateTimePickerProps } from './DatePicker.types'

function getInput(el: HTMLElement): HTMLInputElement | null {
  return el.tagName === 'INPUT'
    ? (el as HTMLInputElement)
    : el.querySelector<HTMLInputElement>('input')
}

function readDateProps(el: HTMLElement): DatePickerProps {
  const d = el.dataset
  const input = getInput(el)
  return {
    name: d.rdName ?? input?.name ?? '',
    label: d.rdLabel ?? '',
    placeholder: d.rdPlaceholder ?? '',
    required: d.rdRequired === 'true',
    disabled: input?.disabled ?? d.rdDisabled === 'true',
    floating: d.rdFloating === 'true',
    size: (d.rdSize ?? 'medium') as 'medium' | 'large',
    clearable: d.rdClear === 'true',
    initialValue: d.rdInitialValue ?? input?.value ?? '',
  }
}

function readDateTimeProps(el: HTMLElement): DateTimePickerProps {
  const d = el.dataset
  const input = getInput(el)
  return {
    name: d.rdName ?? input?.name ?? '',
    dateLabel: d.rdDateLabel || d.rdLabel || undefined,
    timeLabel: d.rdTimeLabel || undefined,
    required: d.rdRequired === 'true',
    disabled: input?.disabled ?? d.rdDisabled === 'true',
    floating: d.rdFloating === 'true',
    size: (d.rdSize ?? 'medium') as 'medium' | 'large',
    clearable: d.rdClear === 'true',
    initialValue: d.rdInitialValue ?? input?.value ?? '',
  }
}

function mount(el: HTMLElement, component: React.FC<any>, props: object): void {
  const root = document.createElement('div')
  root.style.display = 'contents'
  el.replaceWith(root)
  ReactDOM.createRoot(root).render(React.createElement(component, props))
}

const SKIP_INIT = '[data-rd-init], .empty-form'

export function initDatePickerFields(root: ParentNode = document): void {
  root
    .querySelectorAll<HTMLElement>('[data-rd-datetimepicker]')
    .forEach(el => {
      if (el.closest(SKIP_INIT)) return
      mount(el, DateTimePickerField, readDateTimeProps(el))
    })

  root
    .querySelectorAll<HTMLElement>('[data-rd-datepicker]')
    .forEach(el => {
      if (el.closest(SKIP_INIT)) return
      mount(el, DatePickerField, readDateProps(el))
    })
}

export function mountDateTimePicker(
  el: HTMLElement,
  props: Partial<DateTimePickerProps>,
): void {
  mount(el, DateTimePickerField, { name: '', ...props })
}
